/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IEscrowMembershipRemoveMutationVariables = Types.Exact<{
  escrowMembershipId: Types.Scalars['ID']['input'];
}>;

export type IEscrowMembershipRemoveMutation = {
  __typename?: 'Mutation';
  escrowMembershipRemove?: {
    __typename?: 'EscrowMembershipRemovePayload';
    errors?: Array<string> | null;
    success: boolean;
  } | null;
};

export const EscrowMembershipRemoveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'escrowMembershipRemove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowMembershipId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrowMembershipRemove' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowMembershipId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowMembershipId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IEscrowMembershipRemoveMutation, IEscrowMembershipRemoveMutationVariables>;
